import React, { useState, useEffect } from 'react';
import { Grid, TextField, Autocomplete } from '@mui/material';

import CONFIG from '@/config';
import axios from 'axios';
import { getRestHeaders } from '@/common/utils/api';

export const CreditTypeSelector = props => {
  const { name, error, onChange, helperText, removeDials } = props;
  const [options, setOptions] = useState<any>([]);
  const [creditTypes, setCreditTypes] = useState<any>([]);
  const [selectedOption, setSelectedOption] = useState<any>(null);
  const [creditTypeDataLoading, setCreditTypeDataLoading] = useState(true);

  const getCreditTypeData = async () => {
    setCreditTypeDataLoading(true);
    await axios
      .get(`${CONFIG.FINANCE_API_URL}/staff/credit-types`, {
        params: {
          removeDials: removeDials ? true : false
        },
        headers: getRestHeaders()
      })
      .then(response => {
        try {
          const res = response?.data?.data || [];
          setOptions(mapCreditTypeToOptions(res));
          setCreditTypes(res);
        } catch (e) {
          console.log(e);
        }
      })
      .catch(e => {
        console.log(e);
      })
      .finally(() => {
        setCreditTypeDataLoading(false);
      });
  };

  useEffect(() => {
    getCreditTypeData();
  }, []);

  const mapCreditTypeToOptions = data => {
    return data.map(item => {
      return {
        id: item?.id,
        name: item?.description
      };
    });
  };

  const handleAutocomplete = (event, newValue) => {
    const credit = creditTypes.find(c => c?.id === newValue?.id);

    if (newValue != null) {
      setSelectedOption({
        id: credit.id,
        name: credit.description
      });
      onChange({
        ...event,
        ...{ target: { value: newValue?.id, name } }
      });
    } else {
      setSelectedOption(null);
    }
  };

  return (
    <Grid container>
      <Grid item xs={12}>
        <Autocomplete
          options={creditTypeDataLoading ? [] : options}
          disableClearable={true}
          onChange={handleAutocomplete}
          loading={creditTypeDataLoading}
          getOptionLabel={options => options.name}
          value={selectedOption}
          renderInput={params => (
            <TextField
              fullWidth
              {...params}
              error={error}
              helperText={helperText}
              label="Credit Descriptions..."
            />
          )}
        />
      </Grid>
    </Grid>
  );
};
